import React, { useEffect, useState } from "react";
import { API_BASE } from "../config";
import { authHeaders } from "../utils/authHeaders";

function StockReport() {
  const [stock, setStock] = useState([]);

  const loadStock = async () => {
    const res = await fetch(`${API_BASE}/reports/stock`, {
      headers: authHeaders(),
    });
    const data = await res.json();
    setStock(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    loadStock();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Stock Report</h2>

      <table
        style={{
          width: "100%",
          marginTop: "20px",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ background: "#ddd" }}>
            <th style={{ padding: "8px", textAlign: "left" }}>Agent</th>
            <th style={{ padding: "8px", textAlign: "left" }}>Product</th>
            <th style={{ padding: "8px", textAlign: "right" }}>Allocated Qty</th>
            <th style={{ padding: "8px", textAlign: "right" }}>Available Qty</th>
          </tr>
        </thead>

        <tbody>
          {stock.map((row, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
              <td style={{ padding: "8px" }}>{row.agent}</td>
              <td style={{ padding: "8px" }}>{row.product}</td>
              <td style={{ padding: "8px", textAlign: "right" }}>
                {row.allocated_qty}
              </td>
              <td style={{ padding: "8px", textAlign: "right" }}>
                {row.available_qty}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default StockReport;
